module.exports = __webpack_public_path__ + "img/Tucan.7915537d.svg";